module.exports = __webpack_public_path__ + "static/media/uberEats-3b.7238887c.png";